import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'formatTimestamp',
  standalone: true
})
export class FormatTimestampPipe implements PipeTransform {

  transform(value: string, format: string = 'medium'): any {
    if (!value) {
      return '';
    }

    let timestamp;
    if (!isNaN(Number(value))) {
      timestamp = parseInt(value, 10);
    } else {
      const match = value.match(/>(\d+)</);
      if (match && match[1]) {
        timestamp = parseInt(match[1], 10);
      }
    }

    if (timestamp) {
      const date = new Date(timestamp * 1000);
      return new DatePipe('en-US').transform(date, format);
    }

    return value;
  }
}
